import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid", "aria-pressed"]

import { computed } from 'vue'
import { mdiMapMarkerRadiusOutline } from '@mdi/js'

import SVGIcon from '@/components/SVGIcon.vue'

const TITLE = 'Tentativas de check'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    testId: {},
    isActive: { type: Boolean, default: false },
    size: { default: 'normal' }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





// Mesma linguagem visual dos botões redondos vizinhos (PadlockButton /
// HistoryButton): círculo branco com borda `primary30`, preenchido quando ativo.
//
// `border-solid` explícito porque a raiz aqui é um `<button>`, e não um `<div>`
// como nos vizinhos: o reset do Vuetify (`button { border-style: none }`, que
// entra depois do `tailwind.css` em `app.ts`) anula o `border-style: solid` do
// preflight. Sem ele, `border-2` define só a largura e a borda não aparece.
const containerClass = computed(() => [
  'flex items-center justify-center rounded-full border-2 border-solid border-primary30 shadow-md transition-colors duration-200 cursor-pointer text-primary30',
  props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12',
  props.isActive ? 'bg-[#D5EDF2]' : 'bg-white hover:bg-[#D5EDF2]'
])

const iconClass = computed(() => (props.size === 'small' ? 'w-5 h-5' : 'w-6 h-6'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "data-testid": _ctx.testId,
    title: TITLE,
    "aria-label": TITLE,
    "aria-pressed": _ctx.isActive,
    class: _normalizeClass(containerClass.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createVNode(SVGIcon, {
      path: _unref(mdiMapMarkerRadiusOutline),
      class: _normalizeClass(iconClass.value)
    }, null, 8, ["path", "class"])
  ], 10, _hoisted_1))
}
}

})